import daysDiff from '../../../utils/daysDiff';

const getUserRelapseAccess = user => {
  const { progress, role, id } = user;
  if (!id) return true;
  if (role === 'support') return false;

  const {
    module,
    clocks: { last_attempt_start }
  } = progress;

  return last_attempt_start && module > 0
    ? daysDiff(last_attempt_start) < 7
    : false;
};

export default getUserRelapseAccess;



// WEBPACK FOOTER //
// ./src/containers/Dashboard/utils/getUserRelapseAccess.js